import * as signalR from "@microsoft/signalr";
import { getToken, getEncryptedToken } from "@/utils/auth"; // get token from cook
import { userNotificationsGet, notificationSetAsRead, notificationSetAllAsRead } from "@/api/notification";

const state = {
    signalRConnection: null,
    notifications: null,
    displayUnreadNotificationCount: null,
    unreadNotificationCount: null
};

const mutations = {
    SET_SIGNAL_R_CONNECTION: (state, connection) => {
        state.signalRConnection = connection;
    },
    ADD_NEW_NOTIFICATION: (state, notification) => {
        state.notifications.items.unshift(notification);
        console.log("state.notifications.items", state.notifications.items);
        state.unreadNotificationCount = state.unreadNotificationCount + 1;
        state.displayUnreadNotificationCount = state.displayUnreadNotificationCount + 1;
    },
    PUSH_MULTIPLE_NOTIFICATIONS: (state, notifications) => {
        state.notifications.items.push(...notifications.items);
    },
    SET_NOTIFICATIONS: (state, data) => {
        state.notifications = data;
        state.unreadNotificationCount = data.unreadCount;
        state.displayUnreadNotificationCount = data.unreadCount;
    },
    SET_DISPLAY_UNREAD_COUNT: (state, count) => {
        state.displayUnreadNotificationCount = count;
    },
    SET_NOTIFICATION_AS_READ: (state, id) => {
        let message = state.notifications.items.find((item) => item.id == id);
        message.state = 1;

        state.unreadNotificationCount = state.unreadNotificationCount - 1;
    },
    SET_ALL_NOTIFICATIONS_AS_READ: (state) => {
        state.notifications.items = state.notifications.items.map(item => {
            return {
                ...item,
                state: 1
            };
        });

        state.unreadNotificationCount = null;
        state.displayUnreadNotificationCount = null;
    },
};

const actions = {
    async initSignalR({ commit }) {
        let token =  await getToken();
        let encrypted_token =  await getEncryptedToken();
        let encoded_encrypted_token = await encodeURIComponent(encrypted_token);

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(`${process.env.ROOT_API}/signalr?enc_auth_token=${encoded_encrypted_token}`, {
            // skipNegotiation: true,
            // withCredentials: false,
                transport: signalR.HttpTransportType.WebSockets,
                accessTokenFactory: () => {
                    return token;
                },
            
            })
            .configureLogging(signalR.LogLevel.Debug)
            .withAutomaticReconnect()
            .build();

        connection.on("getMessage", data => {
            console.log("getMessage", data);
        });

        connection.on("getNotification", notification => {
            commit("ADD_NEW_NOTIFICATION", notification);

            function showNotification(n) {
                console.log("notification", n);
                const notification = new Notification(n.notification.data.properties.Message, {
                    icon: require("@/assets/images/agrinome_logo/agrinome_logo.jpg")
                });

                const audio = new Audio(require("@/assets/audio/alert_sound.ogg"));
                audio.play();
            }

            if (Notification.permission === "granted") {
                showNotification(notification);
            } else if (Notification.permission !== "denied") {
                Notification.requestPermission().then(permission => {
                    if (permission === "granted") {
                        showNotification(notification);
                    }
                });
            }
        });

        connection.on("connected", data => {
            console.log("connected");
        });

        connection.start().then(() => {  commit("SET_SIGNAL_R_CONNECTION", connection);  });
    },
    async getAllNotifications({ commit, dispatch }, notificationPagination) {
        let res = await userNotificationsGet({ ...notificationPagination });
        if (res) {
            commit("SET_NOTIFICATIONS", res); 
        }
    },
    async getMoreNotifications({ commit }, notificationPagination) {
        let res = await userNotificationsGet({ ...notificationPagination });
        if (res) {
            commit("PUSH_MULTIPLE_NOTIFICATIONS", res); 
        }
    },
    async setDisplayUnreadCount({ commit }, count) {
        commit("SET_DISPLAY_UNREAD_COUNT", count); 
    },
    async setNotificationAsRead({ commit }, id) {
        let res = await notificationSetAsRead({ "id": id });
        if (res) {
            commit("SET_NOTIFICATION_AS_READ", id); 
        }
    },
    async setAllNotificationsAsRead({ commit }) {
        let res = await notificationSetAllAsRead();
        if (res) {
            commit("SET_ALL_NOTIFICATIONS_AS_READ"); 
        }
    },
    updatePageTitle({ commit, state }, count) {
        let unread_title = count ? `(${count}) ` : "";
        // let title = router.history.current?.meta?.title + ' - Darwin Portal' || 'Darwin Portal'
        let title = "Agrinome";
        document.title = unread_title + title;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/signalr.js